<template>
  <body>
    <Header></Header>
    <img src="map.png" class="logo" height="50px" width="50px" />
    <span class="title">Country Variation</span>
    <div>
      
      <!--Netflix Content Overview-->
      <div id="text1">
        <h1>2008 - 2019: Who were feeding Netflix content ?</h1>
        <h4>Dark Blue: 😍 Tons of Contributions!</h4>
        <h4>Grey: 😅 Oops Nothing...</h4>
      </div>
      <div id="svgchor">
        <svg
          id="chor"
          style="background-color: #272727"
          width="960"
          height="600"
        ></svg>
      </div>

      <!--2019, compare by countries with 10 more contents-->
      <div id="text2">
        <h1>Keep Digging 🤔: What's the story in 2019 ?</h1>
        <h3>Narrow down to countries have exported content more than 10.</h3>
      </div>
      <div id="svgpro">
        <svg
          id="pro"
          style="background-color: #272727"
          width="960"
          height="600"
        ></svg>
      </div>
    </div>
    <router-link to="/bar_chart_race" @click.native="scrollToTop">
      <div class="next">
        <img src="next.png" height="50px" width="50px" />
      </div>
    </router-link>
  </body>
</template>

<script>
import * as d3 from "d3";
import * as topojson from "topojson";
import Header from "@/components/Header";
export default {
  name: "Map",
  components:{
    Header
  },
  data: function () {
    return {
      countries_map: null,
      total_data: null,
      year2019_data: null,
      movie_tv: null,
    };
  },
  mounted: function () {
    console.log("mounted");

    if (!this.$store.state.countries_map) {
      d3.json("countries-110m copy.json").then((data) => {
        this.countries_map = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("countries_map", this.countries_map);

        if (!this.$store.state.total_data) {
          d3.json("total.json").then((data) => {
            this.total_data = data;
            // console.log("chartData set from file");
            // console.log("chartData contains", this.chartData.length, "rows");
            this.$store.commit("total_data", this.total_data);

            this.chor();
          });
        } else {
          this.total_data = this.$store.state.total_data;
          //console.log("chartData set from store");
          //console.log("chartData contains", this.sunburst_data.length, "rows");
          this.chor();
        }

        if (!this.$store.state.year2019_data) {
          d3.json("year2019.json").then((data) => {
            this.year2019_data = data;
            // console.log("chartData set from file");
            // console.log("chartData contains", this.chartData.length, "rows");
            this.$store.commit("year2019", this.year2019_data);

            this.pro2019();
          });
        } else {
          this.year2019_data = this.$store.state.year2019_data;
          //console.log("chartData set from store");
          //console.log("chartData contains", this.sunburst_data.length, "rows");

          this.pro2019();
        }
      });
    } else {
      this.countries_map = this.$store.state.countries_map;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      if (!this.$store.state.total_data) {
        d3.json("total.json").then((data) => {
          this.total_data = data;
          // console.log("chartData set from file");
          // console.log("chartData contains", this.chartData.length, "rows");
          this.$store.commit("total_data", this.total_data);

          this.chor();
        });
      } else {
        this.total_data = this.$store.state.total_data;
        //console.log("chartData set from store");
        //console.log("chartData contains", this.sunburst_data.length, "rows");
        this.chor();
      }

      if (!this.$store.state.year2019_data) {
        d3.json("year2019.json").then((data) => {
          this.year2019_data = data;
          // console.log("chartData set from file");
          // console.log("chartData contains", this.chartData.length, "rows");
          this.$store.commit("year2019_data", this.year2019_data);

          this.pro2019();
        });
      } else {
        this.year2019_data = this.$store.state.year2019_data;
        //console.log("chartData set from store");
        //console.log("chartData contains", this.sunburst_data.length, "rows");

        this.pro2019();
      }
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    chor() {
      function legend({
        color,
        title,
        tickSize = 6,
        width = 320,
        height = 44 + tickSize,
        marginTop = 18,
        marginRight = 0,
        marginBottom = 16 + tickSize,
        marginLeft = 0,
        ticks = width / 64,
        tickFormat,
        tickValues,
      } = {}) {
        const svg2 = d3
          .create("svg")
          .attr("width", width)
          .attr("height", height)
          .attr("viewBox", [0, 0, width, height])
          .style("overflow", "visible")
          .style("display", "black");

        let x;

        // Discrete
        if (color.invertExtent) {
          const thresholds = color.thresholds
            ? color.thresholds() // scaleQuantize
            : color.quantiles
            ? color.quantiles() // scaleQuantile
            : color.domain(); // scaleThreshold

          const thresholdFormat =
            tickFormat === undefined
              ? (d) => d
              : typeof tickFormat === "string"
              ? d3.format(tickFormat)
              : tickFormat;

          x = d3
            .scaleLinear()
            .domain([-1, color.range().length - 1])
            .rangeRound([marginLeft, width - marginRight]);

          svg2
            .append("g")
            .selectAll("rect")
            .data(color.range())
            .join("rect")
            .attr("x", (d, i) => x(i - 1))
            .attr("y", marginTop)
            .attr("width", (d, i) => x(i) - x(i - 1))
            .attr("height", height - marginTop - marginBottom)
            .attr("fill", (d) => d);

          tickValues = d3.range(thresholds.length);
          tickFormat = (i) => thresholdFormat(thresholds[i], i);
        }

        svg2
          .append("g")
          .attr("transform", `translate(0, ${height - marginBottom})`)
          .call(
            d3
              .axisBottom(x)
              .ticks(
                ticks,
                typeof tickFormat === "string" ? tickFormat : undefined
              )
              .tickFormat(
                typeof tickFormat === "function" ? tickFormat : undefined
              )
              .tickSize(tickSize)
              .tickValues(tickValues)
          )
          .call((g) =>
            g
              .selectAll(".tick line")
              .attr("y1", marginTop + marginBottom - height)
          )
          .call((g) => g.select(".domain").remove())
          .call((g) =>
            g
              .append("text")
              .attr("y", marginTop + marginBottom - height - 6)
              //.attr("fill", "currentColor")
              .attr("text-anchor", "start")
              .attr("font-weight", "bold")
              .text(title)
          )
          .style("fill", "white")
          .style('color','white')
        // .style("stroke", "white");

        return svg2.node();
      }

      /////////////////////////////////////////////////////////////
      //Choropleth code
      var svg2 = d3.select("#chor"),
        width = +svg2.attr("width"),
        height = +svg2.attr("height");

      var projection = d3
        .geoMercator()
        .translate([width / 2 - 10+10, height / 2 + 115])
        .scale([143]);
      var path = d3.geoPath().projection(projection);

      var world = this.countries_map;
      var data = this.total_data;

      var format = d3.format(",.0f");

      data = new Map(
        data.slice(1).map(([country, counts]) => [country, +counts])
      );
      console.log(data);

      var color = d3.scaleQuantize([100, 500], d3.schemeYlGnBu[8]);

      //legend title
      data.title = "Number of Netflix TV shows & Movies";

      svg2
        .append("g")
        .selectAll("path")
        .data(topojson.feature(world, world.objects.countries).features)
        .join("path")
        .attr("fill", function (d) {
          var value = data.get(d.properties.name);
          if (value) {
            return color(value);
          } else {
            return "#ccc";
          }
        })
        .attr("d", path)
        .append("title")
        .text(function(d){
          if (typeof data.get(d.properties.name)!='undefined'){
            return `${d.properties.name} ${format(data.get(d.properties.name))}`
          }
          else{
            return `${d.properties.name} ${0}`
          }
        }
          
          // (d) => `${d.properties.name} ${format(data.get(d.properties.name))}`
        );

      svg2
        .append("path")
        .datum(topojson.mesh(world, world.objects.countries, (a, b) => a !== b))
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-linejoin", "round")
        .attr("d", path);

      svg2
        .append("g")
        .attr("transform", "translate(610,520)")
        .append(() => legend({ color, title: data.title, width: 260 }));

      //svg2.append('text')
      //.attr('x', 270)
      //.attr('y', 35)
      //.attr('class','title')

      //.text('Who is responsible for Netflix Content')
      //.style('fill','red')
      //.style('stroke','red')
      //.style('font-size', '30')
    },

    pro2019() {
      var svg3 = d3.select("#pro"),
        width = +svg3.attr("width"),
        height = +svg3.attr("height");

      var projection = d3
        .geoMercator()
        .translate([width / 2 - 10, height / 2 + 50])
        .scale([150]);
      var path = d3.geoPath().projection(projection);

      var world = this.countries_map;

      var year2019 = this.year2019_data;

      var format = d3.format(",.0f");

      year2019 = new Map(
        year2019.slice(1).map(([country, counts]) => [country, +counts])
      );
      console.log(year2019);

      var radius = d3.scaleLinear(
        [0, d3.quantile([...year2019.values()].sort(d3.ascending), 1)],
        [10, 60]
      );

      ///////////////////////////////////////////////////////////draw world map
      svg3
        .append("path")
        .datum(topojson.feature(world, world.objects.countries))
        .attr("class", "countries")
        .attr("d", path);

      svg3
        .append("path")
        .datum(topojson.mesh(world, world.objects.countries, (a, b) => a !== b))
        .attr("class", "countries-borders")
        .attr("d", path);

      const legend = svg3
        .append("g")
        .attr("transform", "translate(870,578)")
        .attr("text-anchor", "middle")
        .style("font", "10px sans-serif")
        .selectAll("g")
        .data([10, 100, 200, 500])
        .join("g");

      legend
        .append("circle")
        .attr("fill", "none")
        .attr("stroke", "steelblue")
        .attr("cy", (d) => -radius(d))
        .attr("r", radius);

      legend
        .append("text")
        .attr("y", (d) => -2 * radius(d))
        .attr("dy", "-0.1em")
        .attr("dx", "-0.5em")
        .text(d3.format(".1s"))
        .style("stroke", "steelblue");

      svg3
        .append("g")
        .attr("fill", "steelblue")
        .attr("fill-opacity", 0.9)
        .attr("stroke", "#fff")
        .attr("stroke-width", 0.5)
        .selectAll("circle")
        .data(
          topojson
            .feature(world, world.objects.countries)
            .features.map(
              (d) => ((d.value = year2019.get(d.properties.name)), d)
            )
            .sort((a, b) => b.value - a.value)
        )
        .join("circle")
        .attr("transform", (d) => `translate(${path.centroid(d)})`)
        .attr("r", (d) => radius(d.value))
        .append("title")
        .text((d) => `${d.properties.name} ${format(d.value)}`)
        .transition()
        .duration(700);

      //////////////////////////////////////////////////

      //svg3.append('text')
      //.attr('x', 320)
      //.attr('y', 35)
      //.attr('class','title')
      //.text('Year 2019 - Netflix')
    },
  },
};
</script>


<style scoped>
>>> .countries {
  fill: #f0ead6;
}

>>> .countries-borders {
  fill: none;
  stroke: black;
  stroke-width: 0.5px;
  stroke-linejoin: round;
  stroke-linecap: round;
  pointer-events: none;
}

>>> .filter {
  border-radius: 3px;
  background-color: #eee;
  /* background-color: #eee; */
  padding: 5px;
  margin: 5px;
  color: #444;
  text-align: left;
  display: inline-block;
  cursor: default;
}

h1,
h2,
h3,
h4 {
  color: rgba(255, 255, 255, 0.881);
  text-align: center;
}

body {
  background-color: #121212;
  height: 245vh;
}
.title {
  position: absolute;
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  top: 10%;
  left: 19.5%;
}
.logo {
  position: absolute;
  top: 9%;
  left: 15%;
}
#text1
{
  position: absolute;
  left: 14%;
  top: 20%;
  background-color: #272727;
  border-radius: 15px;

  /* margin: auto; */
  width: 70%;
}
#text2
{
  position: absolute;
  left: 14%;
  top: 127%;
  background-color: #272727;
  border-radius: 15px;

  /* margin: auto; */
  width: 70%;
}

#svgchor{
  position: absolute;
  width: 70.5%;
  top: 42%;
  left: 14%;
  display: flex;
  align-items: center;
}
#svgpro
{
  position: absolute;
  width: 70.5%;
  top: 144%;
  left: 14%;
  display: flex;
  align-items: center;
}
#chor,
#pro,
#inline {
  margin: 0 auto;
  display: block;
  border-radius: 15px;
}
.next {
  position: absolute;
  left: 48%;
  top: 231%;
}
</style>